import React from 'react';
import { Box, Typography, Select, MenuItem, IconButton } from '@mui/material';
import { ChevronLeft as ChevronLeftIcon, ChevronRight as ChevronRightIcon } from '@mui/icons-material';

// Reusable footer used by lists (Transactions, Budgets)
export default function ListFooter({
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  totalCount,
  rowsOptions = [5, 10, 25]
}) {
  const totalPages = Math.max(1, Math.ceil(totalCount / rowsPerPage));

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1, px: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="caption" color="text.secondary">Rows</Typography>
        <Select
          value={rowsPerPage}
          onChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
          size="small"
          sx={{ '& .MuiSelect-select': { py: 0.5, px: 1, fontSize: '0.875rem' }, minWidth: 72 }}
        >
          {rowsOptions.map(n => (
            <MenuItem key={n} value={n}>{n}</MenuItem>
          ))}
        </Select>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconButton size="small" onClick={() => setPage(Math.max(0, page - 1))} disabled={page === 0}>
          <ChevronLeftIcon fontSize="small" />
        </IconButton>
        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.875rem' }}>{page + 1} / {totalPages}</Typography>
        <IconButton size="small" onClick={() => setPage(Math.min(totalPages - 1, page + 1))} disabled={page >= totalPages - 1}>
          <ChevronRightIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
}
